import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-custom-checkbox',
    templateUrl: './custom-checkbox.component.html',
    styleUrls: ['./custom-checkbox.component.scss']
})
export class CustomCheckboxComponent implements OnInit {
    @Output() clicked: EventEmitter<any> = new EventEmitter<any>();
    @Input() checkedState = false;
    @Input() label = '';

    constructor() {
    }

    ngOnInit(): void {
    }

    onClick() {
        this.clicked.emit();
    }
}
